module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter",
    class: {
      open: _vm.getFiltersVisibility, close: !_vm.getFiltersVisibility
    }
  }, [_c('span', {
    staticClass: "filter-icon"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeFiltersVisibility()
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 36 30",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 30l8-5v-8L36 0H0l14 17"
    }
  })])])]), _c('ul', {
    staticClass: "order"
  }, [_c('li', {
    staticClass: "filter"
  }, [_c('span', [_vm._v("Order By")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.order),
      expression: "filters.order"
    }],
    staticClass: "input-select",
    attrs: {
      "name": "order"
    },
    on: {
      "change": function($event) {
        _vm.filters.order = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.orders), function(order) {
    return _c('option', {
      domProps: {
        "value": order.id
      }
    }, [_vm._v(_vm._s(order.text))])
  }))]), _c('li', {
    staticClass: "filter"
  }, [_c('span', [_vm._v("Filter by Kaleider")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.author),
      expression: "filters.author"
    }],
    staticClass: "input-select",
    attrs: {
      "name": "author"
    },
    on: {
      "change": function($event) {
        _vm.filters.author = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._l((_vm.authors), function(author) {
    return _c('option', {
      domProps: {
        "value": author.id
      }
    }, [_vm._v(_vm._s(author.name))])
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15219ef4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/Filters/Filters.pug
// module id = 260
// module chunks = 2